import { Typography } from '@mui/material';
import { isMobile } from 'react-device-detect';
import type { Song } from 'services/store/songs/types';
import useGetSongGenre from 'services/hooks/songs/useGetSongGenre';

type PropsType = {
  song: Song;
};

const SongTagsChips = (props: PropsType) => {
  const { song } = props;

  const { genre } = useGetSongGenre(song);

  return (
    <Typography
      sx={{ whiteSpace: 'break-spaces' }}
      data-testid="songTagChips"
      color="textSecondary"
      variant={isMobile ? 'caption' : 'body1'}
    >
      {genre}
    </Typography>
  );
};

export default SongTagsChips;
